import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getTableName(tableName: string): string {
  const projectId = process.env.PROJECT_ID || "";
  if (!projectId) {
    return tableName;
  }
  return `${projectId.replace(/-/g, "_")}_${tableName}`;
}
